export enum WEBEX_CALLING_THEME {
    DARK = 'darkWebex',
    LIGHT = 'lightWebex',
  }
  export enum THEME_CLASS {
    DARK = 'scrollbarColor-dark-theme',
    LIGHT = 'scrollbarColor-light-theme',
  }